import axios from "axios";
import wx from "weixin-js-sdk";

let baseURL = "https://zsrbactivity.zsnews.cn";

// 分享内容填充和调用分享方法
export function share(param) {
  const tempParam = {
    title: param.title,
    desc: param.description,
    link: param.url,
    imgUrl: param.imgUrl,
    success: param.successMethod,
  };
  //分享给朋友
  wx.updateAppMessageShareData(tempParam);
  //分享给朋友圈
  wx.updateTimelineShareData(tempParam);
}

// 页面调用分享功能的方法
export function wxshareInit(param) {
  if (!param) {
    return;
  }
  sign(param);
}

// 向后端请求权限验证配置的基本数据
function sign(param) {
  //https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#62
  //签名算法需要有当前地址（但当前网页的URL，不包含#及其后面部分）
  const pageUrl = window.location.href.split("#")[0];
  axios
    .get(baseURL + "/api/common/wxJsSdkConfig?pageurl=" + pageUrl)
    .then((res) => {
      console.log(res);
      initAPIs(res.data.data, param);
    });
}
// 权限验证数据填充
function initAPIs(data, shareParam) {
  wx.config({
    debug: data.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: data.appId,
    timestamp: data.timestamp,
    nonceStr: data.nonceStr,
    signature: data.signature,
    jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
    openTagList: ["wx-open-launch-app"],
  });
  // 验证成功后执行的方法
  wx.ready(function () {
    if (shareParam) {
      console.log(shareParam);
      share(shareParam);
    }
  });
  // 判断客户端是否支持指定js的接口
  wx.checkJsApi({
    jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
    success: function (res) {
      return res;
    },
  });
}
